// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"60f7841c","598":"74ce21d7","703":"ec547275","787":"99e17f56"}[chunkId] + ".chunk.js";
};